import { render } from "./excelTemplateBox.vue?vue&type=template&id=0bb552de"
import script from "./excelTemplateBox.vue?vue&type=script&lang=js"
export * from "./excelTemplateBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/setting/templateSetting/components/excelTemplateBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bb552de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bb552de', __exports__)) {
    api.reload('0bb552de', __exports__)
  }
  
  module.hot.accept("./excelTemplateBox.vue?vue&type=template&id=0bb552de", () => {
    api.rerender('0bb552de', render)
  })

}


export default __exports__